/**
 * @file 차계부(법인차량 운행일지) API
 * 차량 카탈로그(사진 포함) + 월별 운행일지 CRUD.
 */
import { api } from "../../../util/api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const V = `${API_BASE}/vehicles`;
const L = `${API_BASE}/vehicle-logs`;
const M = `${API_BASE}/vehicle-maintenance`;

export const vehicleApi = {
    // ─── 차량 (카드) ─────────────────────────────────────────────
    /** 차량 목록 — 누적 KM·기록 수 포함 */
    getVehicles: (includeInactive = false) => api.get(V, { includeInactive }),
    getVehicle:  (id)        => api.get(`${V}/${id}`),
    createVehicle: (data)    => api.post(V, data),
    updateVehicle: (id, data) => api.put(`${V}/${id}`, data),
    deleteVehicle: (id)      => api.delete(`${V}/${id}`),

    /** 차량 사진 업로드 (이미지 파일) */
    uploadVehicleImage: (id, file) => {
        const fd = new FormData();
        fd.append("file", file);
        return api.upload(`${V}/${id}/image`, fd);
    },
    deleteVehicleImage: (id) => api.delete(`${V}/${id}/image`),

    // ─── 운행일지 ────────────────────────────────────────────────
    /** 월별 운행일지 + 요약. vehicleId 를 비우면 전 차량 통합. */
    getMonthlyLogs: (vehicleId, year, month) =>
        api.get(L, { ...(vehicleId ? { vehicleId } : {}), year, month }),
    /** 운행 목적 코드 목록 (드롭다운) */
    getPurposes: () => api.get(`${L}/purposes`),
    /** 직전 계기판 — 새 기록의 '주행 전' 기본값 */
    getLastLog: (vehicleId) => api.get(`${L}/last`, { vehicleId }),
    /** 최근에 쓰인 주차 위치 — 입력칸 제안 (목록 밖 값도 입력 가능) */
    getParkingLocations: () => api.get(`${L}/parking-locations`),

    createLog: (data)     => api.post(L, data),
    updateLog: (id, data) => api.put(`${L}/${id}`, data),
    deleteLog: (id)       => api.delete(`${L}/${id}`),

    // ─── 정비 ────────────────────────────────────────────────────
    /** 정비 탭 한 판 — 항목별 다음 시점·남은 거리 + 이력 + 요약 */
    getMaintenance: (vehicleId) => api.get(M, { vehicleId }),
    /** 전 차량 초과·임박 건수 — 차량 카드 배지 */
    getMaintenanceBadges: () => api.get(`${M}/badges`),

    createMaintenanceItem: (data)     => api.post(`${M}/items`, data),
    updateMaintenanceItem: (id, data) => api.put(`${M}/items/${id}`, data),
    deleteMaintenanceItem: (id)       => api.delete(`${M}/items/${id}`),

    /** 정비 이력 작성 — itemIds 를 여러 개 담으면 항목 수만큼 기록이 생긴다 */
    createMaintenanceRecords: (data)     => api.post(`${M}/records`, data),
    updateMaintenanceRecord: (id, data)  => api.put(`${M}/records/${id}`, data),
    deleteMaintenanceRecord: (id)        => api.delete(`${M}/records/${id}`),

    // ─── 참조 데이터 ─────────────────────────────────────────────
    /** 로그인 사용자 — 운행자 기본값(본인)으로 쓴다. */
    getMe: () => api.get(`${API_BASE}/employees/me`),
};
